import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

interface HStackProps {
  $spacing?: number;
  $valign?: 'top' | 'center' | 'bottom' | 'baseline';
  $wrap?: boolean;
}

export const HStack = styled.div.attrs(() => ({
  role: 'presentation',
}))<HStackProps>`
  display: flex;

  ${({ $spacing }) =>
    $spacing &&
    css`
      gap: ${size($spacing)};
    `}

  ${({ $wrap }) =>
    $wrap &&
    css`
      flex-wrap: wrap;
    `}

  ${({ $valign }) =>
    $valign === 'top'
      ? css`
          align-items: start;
        `
      : $valign === 'center'
        ? css`
          align-items: center;
        `
        : $valign === 'bottom'
          ? css`
          align-items: end;
        `
          : $valign === 'baseline'
            ? css`
          align-items: baseline;
        `
            : undefined}
`;
